import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import UserReducer from './slices/user';
import PageReducer from './slices/page';

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return {};
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const saveState = (state: unknown) => {
  localStorage.setItem('state', JSON.stringify(state));
};

export const store = configureStore({
  reducer: {
    user: UserReducer.reducer,
    page: PageReducer.reducer
  },
  preloadedState: {
    user: loadState()
  },
  devTools: process.env.NODE_ENV !== 'production'
});

window.onbeforeunload = function () {
  const userState = store.getState().user;
  saveState(userState);
};

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;